"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const request_1 = require("../requests/request");
class API {
    /**
     * Fetches the curated sets that are followed by the user
     * @returns {Promise<Curated[]>} The Promise contains an APIError if rejected
     */
    static getFollowedCuratedSets() {
        let apiRequest = new request_1.AuthenticatedRequest('/followedsets', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.Curated).then((response) => {
            return response.data;
        });
    }
    /**
     * Follows the curated set
     * id - string
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static followCuratedSet(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/followedsets/' + id, request_1.HTTPMethod.POST, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Follows the curated set
     * id - string
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static unfollowCuratedSet(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/followedsets/' + id, request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Fetches the users's playlists
     * @returns {Promise<Playlist[]>} The Promise contains an APIError if rejected
     */
    static getPlaylists() {
        let apiRequest = new request_1.AuthenticatedRequest('/playlists/', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.Playlist).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches a playlist by id
     * @returns {Promise<Playlist>} The Promise contains an APIError if rejected
     */
    static getPlaylist(playlist_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/playlists/' + playlist_id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.Playlist).then((response) => {
            return response.data;
        });
    }
    /**
     * Creates a playlist
     * title - string
     * songs - An array of the track's id's
     * @returns {Promise<Playlist>} The Promise contains an APIError if rejected
     */
    static createPlaylist(title, songs) {
        let apiRequest = new request_1.AuthenticatedRequest('/playlists/', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            title: title,
            songs: songs
        });
        return apiRequest.send(models_1.Playlist).then((response) => {
            return response.data;
        });
    }
    /**
     * Updates a playlist
     * title - Updates the title
     * add_songs - Songs to add to the playlist
     * remove_songs - Songs to remove from the playlist
     * @returns {Promise<Playlist>} The Promise contains an APIError if rejected
     */
    static updatePlaylist(playlist_id, title, add_songs, remove_songs) {
        let apiRequest = new request_1.AuthenticatedRequest('/playlists/' + playlist_id, request_1.HTTPMethod.PUT, request_1.APIVersion.v1_2, undefined, {
            title: title,
            add_songs: add_songs,
            delete_songs: remove_songs
        });
        return apiRequest.send(models_1.Playlist).then((response) => {
            return response.data;
        });
    }
    /**
     * Deletes a playlist
     * @returns {Promise<Playlist>} The Promise contains an APIError if rejected
     */
    static deletePlaylist(playlist_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/playlists/' + playlist_id, request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2);
        return apiRequest.send().then(() => {
            return void 0;
        });
    }
    /**
     * Uploads a new image for the playlist
     * @param {string} image - The uri for the image to set
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    static uploadPlaylistImage(playlist_id, image) {
        let apiRequest = new request_1.AuthenticatedFileRequest('/playlists/' + playlist_id + '/picture', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            image: image
        });
        return apiRequest.send(models_1.Playlist).then((response) => {
            return response.data;
        });
    }
}
exports.API = API;
